import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1fff550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "similarity" }
const _hoisted_2 = { class: "message" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-text" }, "very different", -1))
const _hoisted_4 = { class: "comparison" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "People in the last file used:", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "People in this file:", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Random person matches:", -1))
const _hoisted_10 = { class: "value" }

import { computed } from 'vue'
import { WorkspaceComparison } from './SyncSessionModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncComparison',
  props: {
    comparison: {},
    lastPersonCount: {}
  },
  setup(__props: any) {

const props = __props;



const tierRef = computed(() => props.comparison.similarityTo(props.lastPersonCount))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (tierRef.value === 'high')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("This file is very similar to the last file used to sync this tree.")
          ], 64))
        : (tierRef.value === 'medium')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("This file is somewhat similar to the last file used to sync this tree.")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode("This file is "),
              _hoisted_3,
              _createTextVNode(" from the last file used to sync this tree.")
            ], 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.lastPersonCount !== undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lastPersonCount.toLocaleString()), 1)
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.comparison.sourcePersonCount?.toLocaleString()), 1),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.comparison.matchRateText), 1)
    ])
  ]))
}
}

})